/* ----------------------------- */
/*   Reducer for the Remedy Reference CRQ Set
/* ----------------------------- */

import {
  FETCH_REMEDY_REFERENCE_CRQ_ERROR, CLEAR_REMEDY_REFERENCE_CRQ_ERROR, FETCH_REMEDY_REFERENCE_CRQ, FETCH_REMEDY_REFERENCE_CRQ_REQUEST, FETCH_REMEDY_REFERENCE_CRQ_SUCCESS, SET_RELATED_COORDINATOR_ID, CLEAR_RELATED_COORDINATOR_ID,
} from 'AppSrc/core/actions/actions-edit-form';

const remedyReferenceCrqState = {
  crqData: {},
  fetching: false,
  error: '',
  selectedRelCordinator: '',
};

const remedyReferenceCrqReducer = (state = remedyReferenceCrqState, action) => {

  switch (action.type) {
    // Set remedy refernce data
    case FETCH_REMEDY_REFERENCE_CRQ: {
      console.log('fetch remedy ref reducer', action);
      return {
        ...state,
        crqData: {
          ...action.payload.formData,
        },
      };
    }
    // Start get remedy refernce data
    case FETCH_REMEDY_REFERENCE_CRQ_REQUEST: {
      return {
        ...state,
        fetching: true,
      };
    }
    // Success remedy refernce data
    case FETCH_REMEDY_REFERENCE_CRQ_SUCCESS: {
      return {
        ...state,
        fetching: false,
      };
    }
    // Error api remedy refernce data
    case FETCH_REMEDY_REFERENCE_CRQ_ERROR: {
      return {
        ...state,
        error: action.payload.error.message,
      };
    }
    // Clear error ref
    case CLEAR_REMEDY_REFERENCE_CRQ_ERROR: {
      return {
        ...state,
        error: '',
      };
    }
    // Set related coordinator id
    case SET_RELATED_COORDINATOR_ID: {
      return {
        ...state,
        selectedRelCordinator: action.payload.relId,
      };
    }
    // Clear related remedy id
    case CLEAR_RELATED_COORDINATOR_ID: {
      return {
        ...state,
        selectedRelCordinator: '',
      };
    }
    default:
      return state;
  }
};

export {
  remedyReferenceCrqReducer,
  remedyReferenceCrqState,
};
